import React from "react";

const TopUsers = ({ users = [] }) => {
  const topUsers = users;

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 border border-line">
      {/* Header */}
      <div className="mb-4 pb-4 border-b border-line">
        <h2 className="text-lg font-bold text-content mb-1">Top Users</h2>
        <p className="text-sm text-subtle">
          Users with most voicemail messages
        </p>
      </div>

      {/* Users List */}
      {topUsers.length === 0 ? (
        <p className="text-sm text-subtle">No user activity data available yet.</p>
      ) : (
        <div className="space-y-5">
          {topUsers.map((user) => (
            <div key={user.rank} className="flex items-center justify-between">
              {/* Left side: Rank badge and User info */}
              <div className="flex items-center gap-4 flex-1">
                {/* Rank Badge */}
                <div className="w-8 h-8 rounded-full bg-content flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">
                    {user.rank}
                  </span>
                </div>

                {/* User Information */}
                <div className="flex flex-col">
                  <div className="text-base font-semibold text-con">
                    {user.name}
                  </div>
                  <div className="text-xs text-subtle">{user.email}</div>
                </div>
              </div>

              {/* Right side: Message Count */}
              <div className="flex flex-col items-end ml-4">
                <div className="text-base font-semibold text-content">
                  {user.messages}
                </div>
                <div className="text-xs text-subtle">messages</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TopUsers;
